<script setup lang="ts">
defineProps<{
  content: string
}>()
</script>

<template>
  <div class="flex items-end gap-2 animate-slide-up">
    <!-- Avatar -->
    <img
      src="/emily-avatar.jpg"
      alt="Emily"
      class="flex-shrink-0 w-8 h-8 rounded-full object-cover"
    />

    <!-- Message bubble -->
    <div class="max-w-[80%] bg-white rounded-2xl rounded-bl-md px-4 py-3 shadow-sm border border-gray-100">
      <p class="text-gray-800 text-sm whitespace-pre-wrap leading-relaxed">{{ content }}</p>
    </div>
  </div>
</template>
